import { useQuery } from "@1f/react-sdk";
import { query_system_message } from "../query/systemMessageQueries";

export const SystemMessageApi = () => {
    const getSystemMessage = useQuery(
        query_system_message,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );

    const GetLastSystemMessage= async (tenantId,aziendaId) => {
        try {
            let systemMessageResponse = await getSystemMessage.fetch()
            if(systemMessageResponse && systemMessageResponse.data){
                return systemMessageResponse.data.data.system_message[0]
            }
        } catch (error) {
            throw new Error("Errore durante il recupero dei messaggi di sistema: " + error.message);
        }
    }

    return {
        GetLastSystemMessage
    }
}